<template>
  <div class="modal-wrapper">
    <div class="modal" :class="{ 'modal--report': isComingFromReport }">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="search" />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
        <div class="btns-select" v-if="!onlySingleUser">
          <button
            class="btn btn-select filter-toggle"
            :class="{ 'filter-toggle--active': dropdownActive }"
            @click="dropdownActive = !dropdownActive"
          >
            <span class="mck" v-if="filterByGroup._id || filterByPosition._id"
              >e</span
            >
            <span class="mck2" v-else>r</span>
            <template v-if="active === 'groups'">Покажи бригади</template>
            <template v-else-if="active === 'positions'"
              >Покажи длъжности</template
            >
            <span v-else-if="filterByGroup._id">{{ filterByGroup.name }}</span>
            <span v-else-if="filterByPosition._id">{{
              filterByPosition.name
            }}</span>
            <template v-else>Покажи работници</template>
            <div class="filter-dropdown" v-if="dropdownActive" @click.stop>
              <p
                @click.stop="dropdownSelect('groups')"
                :class="{ 'p-selected': active === 'groups' }"
              >
                Покажи бригади
              </p>
              <p
                @click.stop="dropdownSelect('positions')"
                :class="{ 'p-selected': active === 'positions' }"
              >
                Покажи длъжности
              </p>
              <p
                @click.stop="dropdownSelect('users')"
                :class="{
                  'p-selected':
                    active === 'users' &&
                    !filterByGroup._id &&
                    !filterByPosition._id,
                }"
              >
                Покажи работници
              </p>
            </div>
          </button>
          <button
            class="btn btn-select"
            @click="toggleUsers(true)"
            :disabled="active !== 'users'"
          >
            <span class="mck">W</span>
            Всички
          </button>
          <button
            class="btn btn-select"
            @click="toggleUsers(false)"
            :disabled="active !== 'users'"
          >
            <span class="mck">X</span>
            Никой
          </button>
        </div>
      </div>
      <div class="modal-content" v-show="active === 'groups'">
        <p
          class="select-p"
          v-for="g in filteredGroups"
          :key="`group-${g._id}`"
          @click="selectGroup(g)"
        >
          {{ g.name }}
        </p>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="groups.length && !filteredGroups.length"
        >
          Няма намерени резултати за '
          <strong>{{ search }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-show="active === 'positions'">
        <p
          class="select-p"
          v-for="p in filteredPositions"
          :key="`position-${p._id}`"
          @click="selectPosition(p)"
        >
          {{ p.name }}
        </p>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="positions.length && !filteredPositions.length"
        >
          Няма намерени резултати за '
          <strong>{{ search }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-show="active === 'users'">
        <div
          @click="onlySingleUser ? selectTheLastClickedUser(user._id) : null"
          class="modal-content-check"
          :class="{
            'modal-content-check-disabled': user.isDisabled,
            'modal-content-check-planned': user.isPlanned,
          }"
          v-for="(user, index) in filteredUsers"
          :key="`addUsersModal-${user._id}`"
          :title="
            user.isDisabled
              ? 'Служителят е в отпуск.'
              : user.isPlanned
              ? 'Служителят е бил планиран.'
              : ''
          "
        >
          <label class="checkbox-wrapper">
            {{ user.name }}
            <input
              type="checkbox"
              :id="user._id"
              v-model="user.isSelected"
              :disabled="user.isDisabled"
            />
            <span class="checkmark"></span>
          </label>
          <template
            v-if="isComingFromReport ? getAvailableParts(user._id) : false"
          >
            <div
              class="select-wrapper"
              v-if="getAvailableParts(user._id).length"
            >
              <select
                v-model="user.part"
                :class="{ 'select-grey': user.part === '' }"
                @change="updateUser(index)"
              >
                <option value disabled selected hidden>
                  Асоциирай към част
                </option>
                <!-- <option value v-if="user.part">Премахни част</option> -->
                <option
                  v-for="(p, j) in getAvailableParts(user._id)"
                  :value="p"
                  :key="`${user._id}-p-${j}`"
                >
                  {{ p }}
                </option>
              </select>
            </div>
          </template>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="users.length && !filteredUsers.length"
        >
          <template v-if="!search">
            <template v-if="filterByGroup._id"
              >В избраната група няма добавени работници</template
            >
            <template v-if="filterByPosition._id"
              >В избраната длъжност няма добавени работници</template
            >
          </template>
          <template v-if="search">
            Няма намерени резултати за '
            <strong>{{ this.search }}</strong
            >'
          </template>
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()">
          <span class="mck">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "isComingFromReport",
    "usersType",
    "usersRole",
    "incomingUsers",
    "date",
    "parts",
    "onlySingleUser",
    "ignoreUser",
    "getUserGroups",
  ],
  data() {
    return {
      dropdownActive: false,
      active: "users",
      users: [],
      positions: [],
      groups: [],
      search: "",
      filterByGroup: {},
      filterByPosition: {},
    };
  },
  watch: {
    active(to) {
      if (to === "positions") {
        this.getPositions();
      } else if (to === "groups") {
        this.getGroups();
      }
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    filteredPositions() {
      return this.positions.filter((p) => {
        return p.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredGroups() {
      return this.groups.filter((g) => {
        return g.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredUsers() {
      return this.users.filter((u) => {
        if (this.filterByGroup._id) {
          return (
            u.name.toLowerCase().includes(this.search.toLowerCase()) &&
            u.group === this.filterByGroup._id
          );
        } else if (this.filterByPosition._id) {
          return u.name.toLowerCase().includes(this.search.toLowerCase()) &&
            u.position
            ? u.position._id === this.filterByPosition._id
            : false;
        } else {
          return u.name.toLowerCase().includes(this.search.toLowerCase());
        }
      });
    },
  },
  methods: {
    selectTheLastClickedUser(id) {
      setTimeout(() => {
        this.users.forEach((u) => {
          if (u._id.toString() !== id.toString()) {
            this.$set(u, "isSelected", false);
          } else {
            this.$set(u, "isSelected", true);
          }
        });
      }, 100);
    },
    dropdownSelect(x) {
      this.active = x;
      this.dropdownActive = false;
      this.filterByGroup = {};
      this.filterByPosition = {};
      this.sortSelected();
    },
    getPositions() {
      this.$store.dispatch("startLoading");
      this.positions = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/position?active=true`)
        .then((response) => {
          this.positions = response.data;

          this.$store.dispatch("stopLoading");
        });
    },
    updateUser(i) {
      this.$set(this.users, i, this.users[i]);
    },
    getAvailableParts(id) {
      let reported = this.incomingUsers.filter((u) => u._id === id);

      if (reported.length) {
        reported = reported.map((r) => r.part);
        return this.parts.filter((p) => reported.indexOf(p) < 0);
      }

      return this.parts;
    },
    selectPosition(p) {
      this.filterByPosition = p;
      this.sortSelected();
      this.active = "users";
    },
    getGroups() {
      this.$store.dispatch("startLoading");
      this.groups = [];
      let url = `${process.env.VUE_APP_BASE_URI}/group?active=true`;

      if (this.getUserGroups) {
        url += `&getUserGroups=${this.getUserGroups}`;
      }

      this.$http.get(url).then((response) => {
        this.groups = response.data;

        this.$store.dispatch("stopLoading");
      });
    },
    selectGroup(g) {
      this.filterByGroup = g;
      this.sortSelected();
      this.active = "users";
    },
    sortSelected() {
      this.users.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    getAllUsers() {
      let url = `${process.env.VUE_APP_BASE_URI}/auth/users`;

      if (this.usersType) {
        url += `/${this.usersType}`;
      }
      if (this.usersRole) {
        url += `/role/${this.usersRole}`;
      }

      url += "?active=true";

      if (this.ignoreUser) {
        url += `&ignore=${this.ignoreUser}`;
      }

      if (this.getUserGroups) {
        url += `&groupReporter=${this.getUserGroups}`;
      }

      this.$http.get(url).then((response) => {
        this.users = response.data;

        this.users.map((u) => {
          u.part = "";
        });

        if (this.incomingUsers && !this.isComingFromReport) {
          this.incomingUsers.forEach((iu) => {
            this.users.forEach((u) => {
              if (u._id === iu._id) {
                u.isSelected = true;

                if (iu.plannedStartHour) {
                  u.plannedStartHour = iu.plannedStartHour;
                  u.isPlanned = true;
                }

                if (iu.startHour) {
                  u.startHour = iu.startHour;
                }
                if (iu.startHourDate) {
                  u.startHourDate = iu.startHourDate;
                }
                if (iu.endHour) {
                  u.endHour = iu.endHour;
                }
                if (iu.plannedEndHour) {
                  u.plannedEndHour = iu.plannedEndHour;
                }
                if (iu.endHourDate) {
                  u.endHourDate = iu.endHourDate;
                }
                if (iu.position) {
                  u.position = iu.position;
                }
                if (iu.group) {
                  u.group = iu.group;
                }
                if (iu.part) {
                  u.part = iu.part;
                }
              }
            });
          });
        }
        if (this.date) {
          this.getAbsentWorkers();
        }
        this.sortSelected();
      });
    },
    getAbsentWorkers() {
      this.$http
        .get(
          `${
            process.env.VUE_APP_BASE_URI
          }/absence/users/${this.date.toISOString()}`
        )
        .then((response) => {
          const absent = response.data;
          absent.forEach((a) => {
            const i = this.users.map((u) => u._id).indexOf(a._id);
            if (i > -1) {
              this.users[i].isDisabled = true;
              this.$set(this.users, i, this.users[i]);
            }
          });
        });
    },
    toggleUsers(toggle) {
      // If searching or filtered select only results
      if (
        this.search.length ||
        this.filterByGroup._id ||
        this.filterByPosition._id
      ) {
        const tempFilteredUsers = this.filteredUsers;
        this.users.forEach((u, index) => {
          tempFilteredUsers.forEach((fu) => {
            if (fu._id === u._id) {
              if (!u.isDisabled && !u.isPlanned) {
                let user = u;
                user.isSelected = toggle;

                this.$set(this.users, index, user);
              }
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.users.forEach((u, index) => {
          if (!u.isDisabled && !u.isPlanned) {
            let user = u;
            user.isSelected = toggle;

            this.$set(this.users, index, user);
          }
        });
      }
    },
    getSelectedUsers() {
      return this.users.filter((u) => {
      if (u.permissions && u.permissions.isExternalWorker) this.$set(u, "isExternalWorker", true);

        return u.isSelected;
      });
    },
    close() {
      this.$parent.$emit("closeAddUsersModal");
      this.$emit("close");
    },
    save() {
      if (this.isComingFromReport) {
        const su = this.getSelectedUsers();

        for (let u of su) {
          if (u.isSelected && !u.part) {
            return this.$snotify.error(
              "Трябва да изберете част за всеки избран работник"
            );
          }
        }

        this.$parent.$emit("saveAddUsersModal", su);
        this.$emit("saveAddUsersModal", su);
      } else {
        this.$parent.$emit("saveAddUsersModal", this.getSelectedUsers());
        this.$emit("saveAddUsersModal", this.getSelectedUsers());
        this.$emit("close", this.getSelectedUsers());
      }
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        // this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    this.getAllUsers();
    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
/* Responsive */
.modal-header .btns-select .btn:not(:first-child) {
  width: initial;
}
.filter-toggle {
  justify-content: flex-start;
  overflow: hidden;
  position: relative;
}
.filter-toggle .mck,
.filter-toggle .mck2 {
  margin-right: 10px;
}
.filter-toggle--active {
  overflow: initial;
}
.filter-toggle span:not(.mck):not(.mck2) {
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-dropdown {
  background-color: #d3dae2;
  border-radius: 4px;
  box-shadow: 0px 0px 27px #0000006e;
  left: 0;
  position: absolute;
  top: calc(100% + 3px);
  width: 100%;
  padding: 5px 0;
  z-index: 2;
}
.filter-dropdown p {
  align-items: center;
  display: flex;
  padding: 5px;
  padding-left: 35px;
  text-align: left;
  position: relative;
}
.filter-dropdown p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.filter-dropdown p::before {
  color: var(--color-main);
  content: "f";
  display: none;
  font-family: "mck2";
  left: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.filter-dropdown .p-selected::before {
  display: inline;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.btn-select:disabled {
  cursor: default;
  opacity: 0.5;
}
.modal-content-check {
  align-items: center;
}
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  /* .modal-header .new-input {
    width: 72%;
  } */
}
@media screen and (max-width: 600px) {
  /* .modal-content-check {
    width: 45%;
  } */
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
